import React from 'react'
import './Hero.css'
import Subtract from '../../assets/subtract.png'
import Quiz from '../../assets/quiz1.png'
import Ios from '../../assets/IOS-d.svg'
import GooglePlay from '../../assets/google-play-badge.svg'
import { useSpring, animated } from 'react-spring'
import {Bounce} from 'react-reveal';

export const Hero = () => {
    const calc = (x, y) => [x - window.innerWidth/2 , y - window.innerHeight/2 ]
    const trans1 = (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`
    const trans2 = (x, y) => `translate3d(${x / 30}px,${y / 30}px,0)`
    const [props, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 15, tension: 500, friction: 100 } }))
    return (
        <div className={'hero hero-theme'}>
            <div className="hero-text">
                <div className="lg:py-24">
                    <h1 className="mt-4 text-4xl  tracking-tight font-extrabold sm:mt-5 sm:text-6xl lg:mt-6 xl:text-6xl">

                        <span className="block  font-extrabold main-text">Super Over</span>
                        <span className="pb-3 text-4xl lg:text-5xl block bg-clip-text theme-c bg-gradient-to-r from-teal-200 to-cyan-400 sm:pb-5">
                        The ultimate cricket trivia app
                      </span>
                    </h1>
                    <i className="text-base text-gray-500 sm:text-xl lg:text-lg xl:text-xl">
                        .....so you think you know your cricket trivia ?
                    </i>
                    <div className="download-buttons">
                        <img className='download-button-ios' src={Ios} alt="" onClick={()=>window.location.href ="https://apps.apple.com/in/app/5-penalties/id1558709719#?platform=iphone"}/>
                        <img className='download-button-ios'  src={GooglePlay} alt="" onClick={()=>window.location.href ="https://play.google.com/store/apps/details?id=com.hustlecreatives.penalty_kick_freelance"}/>
                    </div>
                </div>
            </div>


            <Bounce right>
                <div className="hero-image" onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}>
                    <animated.img style={{ transform: props.xy.interpolate(trans1) }} className={'subtract'} src={Subtract} alt="" />
                    <animated.img className={'quiz'} style={{ transform: props.xy.interpolate(trans2) }} src={Quiz} alt="" />
                </div>
            </Bounce>


        </div>
    )
}
